export default ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
